/* eslint-disable */
/* tslint:disable */

import { pathgen } from 'object-path-generator';
const createProxyImpl = function createProxyImpl() {
  let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {
    for (var _len = arguments.length, _ref = new Array(_len), _key = 0; _key < _len; _key++) {
      _ref[_key] = arguments[_key];
    }
    let [k] = _ref;
    return k;
  };
  return pathgen(undefined, function (path) {
    const finalPath = path.split('.$value')[0];
    for (var _len2 = arguments.length, options = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      options[_key2 - 1] = arguments[_key2];
    }
    return t(finalPath, ...options);
  });
};
export function LocaleKeys(t) {
  return createProxyImpl(t);
}